import type { Ads } from '../components/chat'
import { toast } from 'react-toastify'

export const generateRandomAds = (ads: Ads[]) => {
  try {
    if (!Array.isArray(ads)) {
      throw new Error('Input is not a valid array of ads.')
    }
    const premiumAds = ads?.filter(ad => ad?.category_name === 'Premium')
    if (premiumAds?.length) {
      const array = new Uint32Array(1)
      crypto.getRandomValues(array)
      const randomValue = typeof array[0] === 'number' ? array[0] : 0
      const index = randomValue % premiumAds.length // Secure random index
      return premiumAds[index]
    }
    return null
  } catch (error) {
    toast.error(
      error instanceof Error
        ? `Error in generateRandomAds: ${error.message}`
        : 'Error in generateRandomAds'
    )
    return null
  }
}
